module.exports = __webpack_public_path__ + "static/media/refresh.56153041.svg";